(() => {
  if (window.GetFlySearch) return;
  const classify = (term) => {
    const q = term.toLowerCase().trim().replace(/[’']/g, '').replace(/\s+/g, ' ');
    if (/^(nike (?:matching |tech fleece |tracksuit )?sets?|nike tracksuits?)$/.test(q)) return { kind: 'nike', collection: 'all' };
    if (/^(?:kids?|childrens?) hood(?:ie|y|ies|ys)$/.test(q)) return { kind: 'kids', collection: 'kids' };
    const waist = q.match(/^(?:mens? )?jeans? (?:size |waist |w)?(\d{2})$/) || q.match(/^(?:size |waist |w)?(\d{2}) (?:mens? )?jeans?$/);
    if (waist && +waist[1] >= 24 && +waist[1] <= 70) return { kind: 'jeans', collection: 'men', waist: waist[1] };
    return null;
  };
  const matchingVariants = (product, intent) => {
    const title = product.title.toLowerCase();
    if (intent.kind === 'nike' && !(product.vendor?.toLowerCase() === 'nike' && /\bset\b|sweatsuit|tracksuit/.test(title + ' ' + product.type.toLowerCase()))) return [];
    if (intent.kind === 'kids' && !/hoodie|hoody/.test(title)) return [];
    if (intent.kind === 'jeans' && !/\bjeans?\b|\bdenim\b/.test(title)) return [];
    return product.variants.filter(variant => !intent.waist || new RegExp('^(?:size\\s*|w(?:aist)?\\s*)?' + intent.waist + '(?:\\s*(?:[x×/]|waist|w|inch|inches|"|\\()|$)', 'i').test(variant.size.trim()));
  };
  window.GetFlySearch = { classify, matchingVariants };
  class GetFlySearchResults extends HTMLElement {
    connectedCallback() {
      this.intent = classify(this.dataset.query || '');
      if (!this.intent || this.started) return;
      this.started = true;
      this.hidden = false;
      this.load();
    }
    async load() {
      const status = this.querySelector('[data-status]');
      try {
        const loadPage = async (page) => {
          const url = new URL(this.dataset.root.replace(/\/?$/, '/') + 'collections/' + this.intent.collection, location.origin);
          url.searchParams.set('view', 'getfly-size-data');
          url.searchParams.set('page', page);
          const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Inventory unavailable');
          const data = await response.json();
          if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) throw new Error('Invalid inventory');
          return data;
        };
        const first = await loadPage(1);
        const rest = await Promise.all(Array.from({ length: Math.max(0, first.pages - 1) }, (_, i) => loadPage(i + 2)));
        const products = [first, ...rest].flatMap(page => page.products);
        this.matches = products.map(product => ({ ...product, variants: matchingVariants(product, this.intent) })).filter(product => product.variants.length);
        this.matches = [...new Map(this.matches.map(product => [product.id, product])).values()];
        status.textContent = this.dataset.count.replace('[count]', this.matches.length);
        this.querySelector('[data-explanation]').textContent = this.intent.kind === 'jeans' ? this.dataset.waist.replace('[size]', this.intent.waist) : this.dataset[this.intent.kind];
        this.querySelector('[data-kids-link]').hidden = this.intent.kind !== 'kids';
        this.querySelector('[data-empty]').hidden = this.matches.length > 0;
        this.querySelector('[data-sort]').hidden = this.matches.length < 2;
        this.querySelector('select').addEventListener('change', () => this.render());
        const broader = this.closest('.template-search').querySelector('[data-getfly-keyword-results]');
        const toggle = this.querySelector('[data-broader]');
        broader.hidden = true;
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          broader.hidden = !broader.hidden;
          toggle.setAttribute('aria-expanded', String(!broader.hidden));
        });
        this.render();
      } catch {
        status.textContent = this.dataset.error;
      }
    }
    render() {
      const grid = this.querySelector('[data-grid]');
      const products = [...this.matches];
      const price = p => Math.min(...p.variants.map(v => v.price));
      const sort = this.querySelector('select').value;
      products.sort(sort === 'low' ? (a, b) => price(a) - price(b) : sort === 'high' ? (a, b) => price(b) - price(a) : (a, b) => a.title.localeCompare(b.title));
      const fragment = document.createDocumentFragment();
      products.forEach((product, index) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'getfly-search-card';
        const url = new URL(product.url, location.origin);
        url.searchParams.set('variant', product.variants[0].id);
        link.href = url.pathname + url.search;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.width = 480;
          image.height = 600;
          image.loading = index < 4 ? 'eager' : 'lazy';
          if (index === 0) image.fetchPriority = 'high';
          link.append(image);
        }
        const title = document.createElement('h3');
        title.textContent = product.title;
        const money = document.createElement('p');
        money.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(price(product) / 100);
        const sizes = document.createElement('p');
        sizes.className = 'getfly-search-sizes';
        sizes.textContent = this.dataset.sizes + ' ' + [...new Set(product.variants.map(v => v.size))].join(', ');
        link.append(title, money, sizes);
        li.append(link);
        fragment.append(li);
      });
      grid.replaceChildren(fragment);
    }
  }
  customElements.define('getfly-search-results', GetFlySearchResults);
})();
